/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { CreateDocumentFolderRequestToJSON, CreateDocumentFolderResponseFromJSON, DestroyDocumentFolderResponseFromJSON, GetDocumentFoldersResponseFromJSON, UpdateDocumentFolderRequestToJSON, UpdateDocumentFolderResponseFromJSON } from '../models';
/**
 *
 */
export class ApiUserV1DocumentFolderApi extends runtime.BaseAPI {
    /**
     * 資料フォルダを削除する
     * destroy
     */
    async userV1DocumentFoldersDocumentFolderIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.documentFolderId === null || requestParameters.documentFolderId === undefined) {
            throw new runtime.RequiredError('documentFolderId', 'Required parameter requestParameters.documentFolderId was null or undefined when calling userV1DocumentFoldersDocumentFolderIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/user/v1/document_folders/{document_folder_id}`.replace(`{${'document_folder_id'}}`, encodeURIComponent(String(requestParameters.documentFolderId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => DestroyDocumentFolderResponseFromJSON(jsonValue));
    }
    /**
     * 資料フォルダを削除する
     * destroy
     */
    async userV1DocumentFoldersDocumentFolderIdDelete(requestParameters, initOverrides) {
        const response = await this.userV1DocumentFoldersDocumentFolderIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 資料フォルダを更新する
     * update
     */
    async userV1DocumentFoldersDocumentFolderIdPutRaw(requestParameters, initOverrides) {
        if (requestParameters.documentFolderId === null || requestParameters.documentFolderId === undefined) {
            throw new runtime.RequiredError('documentFolderId', 'Required parameter requestParameters.documentFolderId was null or undefined when calling userV1DocumentFoldersDocumentFolderIdPut.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/user/v1/document_folders/{document_folder_id}`.replace(`{${'document_folder_id'}}`, encodeURIComponent(String(requestParameters.documentFolderId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDocumentFolderRequestToJSON(requestParameters.updateDocumentFolderRequest)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => UpdateDocumentFolderResponseFromJSON(jsonValue));
    }
    /**
     * 資料フォルダを更新する
     * update
     */
    async userV1DocumentFoldersDocumentFolderIdPut(requestParameters, initOverrides) {
        const response = await this.userV1DocumentFoldersDocumentFolderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 資料フォルダの一覧を取得する
     * index
     */
    async userV1DocumentFoldersGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/user/v1/document_folders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => GetDocumentFoldersResponseFromJSON(jsonValue));
    }
    /**
     * 資料フォルダの一覧を取得する
     * index
     */
    async userV1DocumentFoldersGet(initOverrides) {
        const response = await this.userV1DocumentFoldersGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * 資料フォルダを作成する
     * create
     */
    async userV1DocumentFoldersPostRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/user/v1/document_folders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentFolderRequestToJSON(requestParameters.createDocumentFolderRequest)
        }, initOverrides);
        return new runtime.JSONApiResponse(response, jsonValue => CreateDocumentFolderResponseFromJSON(jsonValue));
    }
    /**
     * 資料フォルダを作成する
     * create
     */
    async userV1DocumentFoldersPost(requestParameters = {}, initOverrides) {
        const response = await this.userV1DocumentFoldersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
